import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { LooksOne, LooksTwo } from "@mui/icons-material";

function CalculatorSideVente() {
  return (
    <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          paddingBottom: 2,
          border:2,
          borderRadius:2
        }}
      >
      <Typography paragraph="true">
        Vérifier votre dotation sur le site de ...
      </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "black",
            margin:2,
            color: "goldenrod",
          }}
          onClick={() => {
            // navigate("/reservation/retraitinfo")
          }}
        >
          Vérifier votre dotation
        </Button>

    </Box>
  );
}
export default CalculatorSideVente;
